var exports = {
  "kL": "x234b8571--75ad89--container",
  "LI": "x234b8571--75ad89--header-description",
  "tX": "x234b8571--75ad89--title-container",
};

module.exports = exports;
